module.exports = __webpack_public_path__ + "images/partner4.48d3a598.svg";